





























































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import themeMixin from '@/mixins/themeMixin.js'

// Extend Vue interface to include $common
declare module 'vue/types/vue' {
  interface Vue {
    $common: {
      changeDefaultImage: (event: Event, type: string) => void
      getDefaultImage: (type: string) => string
    }
  }
}

@Component({
  components: {
    VuePerfectScrollbar
  },
  mixins: [themeMixin]
})
export default class Sidebar extends Vue {
    @Prop() isSidebarCollapsed: boolean = false;

    // Computed property for theme colors from store
    get userThemeColors () {
      return this.$store.state.userData && this.$store.state.userData.themeColors
        ? this.$store.state.userData.themeColors
        : null
    }

    // Computed property for theme styles
    get themeStyles () {
      const { createThemeStyles } = require('@/utils/themeUtils')
      return createThemeStyles(this.userThemeColors)
    }

    created () {
      this.$store.dispatch('getAppSettingsKeyValuePair')
    }
}
